export const isNavigationRailSelected = (item, selectedId) => item.id === selectedId;
export const isNavigationRailTierOneSelected = (item, selectedId) => isNavigationRailSelected(item, selectedId) ||
    item.submenu?.some((subitem) => isNavigationRailSelected(subitem, selectedId));
export const isNavigationRailItemSelected = (item, selectedId) => isNavigationRailSelected(item, selectedId) ||
    item.submenu?.some((subitem) => isNavigationRailTierOneSelected(subitem, selectedId));
